/**
 * Auth bypass mode for dev environments without Auth0.
 *
 * When `VITE_AUTH_MODE === 'none'`, the SPA renders without consulting Auth0
 * at all. Used to ship variant-lens-spa to dev (VPN-gated) before the real
 * Auth0 tenant work (GEN-2815, owned by Mark) lands.
 *
 * Safety: bypass is forbidden when `VITE_APP_ENV` is `staging` or `production`.
 * Both this runtime check and a build-time check in `vite.config.ts` enforce that.
 *
 * Symmetric to `AUTH_MODE` on variant-lens-api (GEN-3025).
 */

export const DEV_BYPASS_USER = {
  email: 'dev-local@inflectionmedicine.com',
  name: 'Local Dev (auth bypass)',
  sub: 'auth0|dev-local-bypass',
} as const

const FORBIDDEN_BYPASS_ENVS = new Set(['staging', 'production'])

export function isDevAuthBypassActive(): boolean {
  if (import.meta.env['VITE_AUTH_MODE'] !== 'none') return false
  const appEnv = String(import.meta.env['VITE_APP_ENV'] ?? '')
  if (FORBIDDEN_BYPASS_ENVS.has(appEnv)) {
    throw new Error(`VITE_AUTH_MODE='none' is forbidden in VITE_APP_ENV='${appEnv}'. ` + `Bypass mode is dev-only.`)
  }
  return true
}
